// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { WarmUpFailureCard } from "../../../components/common/warmUp/WarmUpFailureCard";
import { SUBSCRIPTION_FAILURE_COPY } from "../../../components/common/warmUp/warmUpCopy";
import type { WarmUpFailure } from "../../../services/api/coldStartRetry";

export function SubscriptionReadErrorScreen({
  failure,
  onRetry,
}: {
  failure: WarmUpFailure;
  onRetry: () => void;
}) {
  return <WarmUpFailureCard copy={SUBSCRIPTION_FAILURE_COPY} failure={failure} onRetry={onRetry} />;
}
